import React from "react";
import { Mutation } from "react-apollo";

import { cancelSubscriptionMutation } from "../graphql/billing";
import { Button } from "../components/core/button";

import * as Mixpanel from "../mixpanel";

export class CancelSubscription extends React.Component {
	state = {
		processing: false,
	};

	render() {
		return (
			<Mutation mutation={cancelSubscriptionMutation}>
				{(cancelSubscriptionMutation) => {
					return <Button link={true} classes="js-subscription-cancel" text="Cancel subscription" loading={this.state.processing} onClick={() => {
						this.setState({ processing: true });

						Mixpanel.track("Cancelled paid subscription");

						cancelSubscriptionMutation({
							update: () => {
								this.setState({ processing: false });
							},
							refetchQueries: [ "BillingSubscriptionQuery" ],
						});
					}}/>;
				}}
			</Mutation>
		);
	}
}